/*******************************************************************************
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  *  Copyright © 2020 Pearson Education, Inc.
 *  *  All Rights Reserved.
 *  *
 *  * NOTICE:  All information contained herein is, and remains
 *  * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *  * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *  * patent applications, and are protected by trade secret or copyright law.
 *  * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 ******************************************************************************/


import React from 'react';
import MenuList from '../common/MenuList'
import './header.scss'
import env from '../../common/env';

const Header = (props) => {
    let {userData} = props;
    const logout = () => {
        const piSession = window.piSession;
        if (piSession) {
			piSession.logout();
        }
    };
    const redirectTo = () => {
        window.open(env.EVEREST_HELP_URL)
    }

    const userInitial = userData && userData.firstName ? userData.firstName.toUpperCase().slice(0, 1) + userData.lastName.slice(0, 1).toUpperCase(): 'US';

    return <div className="col-md-12 header">
        <div className="row">

            <div className="col-md-12">
                <MenuList logout={logout} username={userInitial} />
               <span onClick={redirectTo} className="ICONSGeneral24pxhelp-24"></span> 
               {userData.impersonateUserId != null && <div className="impersonate-message"><p>You are currently impersonating this user.</p></div> } 
            </div>
           
        </div>
    </div>
}



export default Header;